import { theme } from "../../style/theme";
import { Button } from "../Button";
import { Icon } from "../Icon/Index";
import { Image } from "../Image";
import { Stack } from "../Stack";
import { Text } from "../Text";
import { StyledCardImageContainer, StyledHouseCard } from "./styled";
import "./style.css";
import { useTranslation } from "react-i18next";
import { log } from "console";

type Props = {
  houseName?: string;
  houseDescription?: string;
  wifi?: boolean;
  doublebeds: number;
  singlebeds: number;
  sofabeds: number;
  laundry?: boolean;
  onClick: () => void;
  imageSrc?: string;
};

export const HouseCard = ({
  houseName,
  doublebeds,
  singlebeds,
  sofabeds,
  houseDescription,
  laundry,
  wifi,
  imageSrc,
  onClick,
}: Props) => {
  const { t } = useTranslation();
  console.log(
    houseName,
    doublebeds,
    singlebeds,
    sofabeds,
    houseDescription,
    laundry,
    wifi,
    imageSrc,
    onClick
  );
  return (
    <StyledHouseCard onClick={onClick}>
      <Stack
        flexDirection="column"
        alignitems="flex-start"
        justifycontent="space-between"
        gap={10}
      >
        <StyledCardImageContainer>
          <Image
            src={
              imageSrc ||
              "https://s3-eu-west-1.amazonaws.com/house.italianway.production/apartment/images/attachments/001/099/619/medium/0B6A9302-Modifica.jpg?1681733056"
            }
            alt="Apparamento"
          />
        </StyledCardImageContainer>

        <Stack
          flexDirection="column"
          justifycontent="flex-start"
          alignitems="flex-start"
          gap={10}
        >
          <Stack flexDirection="column" flex={1}>
            <span className="title-house-card">{houseName}</span>
          </Stack>

          <Stack gap={10}>
            {wifi && (
              <Icon
                iconName="WifiRounded"
                iconColor={theme.colors.black}
                iconSize={30}
              />
            )}
            {laundry && (
              <Icon
                iconName="LocalLaundryServiceRounded"
                iconColor={theme.colors.black}
                iconSize={30}
              />
            )}

            {doublebeds > 0 && (
              <Stack alignitems="center" justifycontent="center" gap={5}>
                <Icon
                  iconName="DoubleBed"
                  iconColor={theme.colors.black}
                  iconSize={30}
                />
                <Text fontSize="sm" bold>
                  {doublebeds?.toString()}
                </Text>
              </Stack>
            )}
            {singlebeds > 0 && (
              <Stack alignitems="center" justifycontent="center" gap={5}>
                <Icon
                  iconName="SingleBed"
                  iconColor={theme.colors.black}
                  iconSize={30}
                />
                <Text fontSize="sm" bold>
                  {singlebeds?.toString()}
                </Text>
              </Stack>
            )}
            {sofabeds > 0 && (
              <Stack alignitems="center" justifycontent="center" gap={5}>
                <Icon
                  iconName="Sofa"
                  iconColor={theme.colors.black}
                  iconSize={25}
                />
                <Text fontSize="sm" bold>
                  {sofabeds?.toString()}
                </Text>
              </Stack>
            )}
          </Stack>
          <Button
            buttonTitle={t("button-discover")}
            icon="ArrowForwardIos"
            onClick={onClick}
          />
        </Stack>
      </Stack>
    </StyledHouseCard>
  );
};
